


<div class="page-box position-relative">
    <app-nav></app-nav>
</div>





<div class="page-box main-box" [ngClass]="{ 'custom-top-padding' : !check_home_page() }">
    <router-outlet></router-outlet>
</div>




<div class="page-box position-relative">
    <app-footer></app-footer>
</div>










<div (click)="whatsapp_chat();" class="align-items-center bg-white border border-dark d-flex flex-row-reverse gap-3 px-3 py-2 rounded-pill shadow whatsupp-box">
    <img class="whatsapp_img" src="../assets/icons/whatsapp.png" width="60" height="60">
    <p class="Connect m-0 fw-bold fs-5">{{"Connect with us" | translate}}</p>
</div>
